module.exports = __webpack_public_path__ + "static/media/0144_Medium.cd673d41.jpg";